import DOMPurify from 'dompurify'
import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'
import { Image } from 'src/components/ui/Image'

interface LearnMoreBannerSectionDataProps {
  title: string
  imageMobile: string
  imageDesktop: string
  subTitle?: string
  description?: string
  buttonText?: string
  buttonLinkAction?: string
}

const LearnMoreBannerSectionData = ({
  title,
  imageMobile,
  imageDesktop,
  subTitle,
  description,
  buttonText,
  buttonLinkAction,
}: LearnMoreBannerSectionDataProps) => {
  return (
    <section className="w-full">
      <div className="bg-[#3A48C6] text-white pt-12 px-[30px] pb-20 w-full">
        <h2 className="text-[40px] font-normal leading-[48px] whitespace-pre-line text-left w-full">
          {title}
        </h2>
      </div>
      <div className="flex flex-row justify-center bg-transparent p-6 items-end gap-6 mt-[-65px]">
        <div className="flex-1">
          {subTitle && (
            <h3 className="text-[22px] font-semibold text-[#101010] mb-2">
              {subTitle}
            </h3>
          )}
        </div>
        <div>
          <Image
            src={imageMobile}
            srcSet={
              imageDesktop
                ? `${imageMobile} 767w, ${imageDesktop} 768w`
                : undefined
            }
            alt={title}
            className="w-[171px] h-[171px] object-cover"
          />
        </div>

        {description && (
          <p
            className="text-sm text-gray-700 leading-relaxed [&_a]:underline [&_a]:font-semibold"
            suppressHydrationWarning
            dangerouslySetInnerHTML={{
              __html:
                typeof DOMPurify?.sanitize === 'function'
                  ? DOMPurify.sanitize(description)
                  : description,
            }}
          />
        )}

        {buttonText && buttonLinkAction && (
          <FlexibleLink
            linkUrl={buttonLinkAction}
            classNames="inline-block mt-2 px-4 py-2 rounded-xl bg-[#3f3dbb] text-white text-sm font-medium text-center"
            label={buttonText}
          />
        )}
      </div>
    </section>
  )
}

export default LearnMoreBannerSectionData
